// stores/invoiceStore.ts
import { JournalEntries } from "types/model.types";
import { create } from "zustand";

type InvoiceStore = {
  invoices: JournalEntries;
  loading: boolean;
  hasFetched: boolean;
  setInvoices: (data: JournalEntries) => void;
  setLoading: (state: boolean) => void;
  setFetched: () => void;
};

export const useInvoiceStore = create<InvoiceStore>((set) => ({
  invoices: [],
  loading: true,
  hasFetched: false,
  setInvoices: (data) => set({ invoices: data }),
  setLoading: (state) => set({ loading: state }),
  setFetched: () => set({ hasFetched: true }),
}));
